import { MARQUEE_ITEMS } from "@/data/destinations";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-8" data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((name, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-serif text-3xl font-light italic text-white/65 md:text-5xl">
              {name}
            </span>
            <span className="text-lg text-[#d4af37]">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050814] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050814] to-transparent" />
    </div>
  );
}
